import styled, { keyframes } from 'styled-components'
import colors from '../../styled/colors'

const getBackground = (type) => {
  if (type === 'success') return colors.feedback.successLight
  if (type === 'error') return colors.feedback.errorLight
  return colors.brand.backgroundBlue
}

const getPositionStyles = (position) => {
  const base = 'z-index: 9999;'
  switch (position) {
    case 'bottom-right':
      return `${base} bottom: 20px; right: 20px;`
    case 'bottom-left':
      return `${base} bottom: 20px; left: 20px;`
    case 'top-right':
      return `${base} top: 20px; right: 20px;`
    case 'top-left':
      return `${base} top: 20px; left: 20px;`
  }
}

const spin = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const ToastContainer = styled.div`
  position: fixed;
  ${({ position }) => getPositionStyles(position)}
  background-color: ${({ type }) => getBackground(type)};
  padding: 12px 24px;
  border-radius: 5px;
  gap: 32px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
  align-items: center;
`

export const ToastMessage = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const ToastText = styled.span`
  color: ${colors.primaryText};
`

export const ToastDismiss = styled.div`
  font-weight: 600;
  cursor: pointer;
  color: ${({ type }) => (type === 'success' ? colors.feedback.success : colors.feedback.error)};
`

export const LoadingSpinner = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid ${colors.brand.backgroundBlue};
  border-top: 3px solid ${colors.brand.lightBlue};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  flex-shrink: 0;
`
